import { useMutation } from "@tanstack/react-query";
import deleteContato from "../queries/deleteContato";

export default function useDeleteContato(onSuccess: () => void, filtro = {}) {
  return useMutation((contatoId : number) => deleteContato(contatoId), {
    onSuccess() {
      onSuccess();
    },
    onError(err : Error) {
      console.log(err.message)
    }
  })
}
